import React from 'react'
import { Plus, Trash2 } from 'lucide-react'

export default function PromosTab({ 
  promoCodes, 
  newPromo, 
  setNewPromo, 
  creating, 
  createPromoCode, 
  deletePromoCode 
}) {
  return (
    <div className="space-y-6">
      {/* Create New Promo */}
      <div className="bg-zinc-800 rounded-2xl p-6 border">
        <h3 className="font-semibold mb-4 flex items-center gap-2">
          <Plus className="w-5 h-5" /> Create Promo Code
        </h3>
        <form onSubmit={createPromoCode} className="grid grid-cols-1 md:grid-cols-5 gap-4">
          <input
            type="text"
            value={newPromo.code}
            onChange={(e) => setNewPromo({...newPromo, code: e.target.value.toUpperCase()})}
            placeholder="CODE"
            className="px-4 py-2 border rounded-lg font-mono uppercase"
            required
          />
          <select
            value={newPromo.plan}
            onChange={(e) => setNewPromo({...newPromo, plan: e.target.value})}
            className="px-4 py-2 border rounded-lg"
          >
            <option value="premium">Premium</option>
            <option value="coach">Coach</option>
            <option value="club">Club</option>
          </select>
          <input
            type="number"
            value={newPromo.duration_days}
            onChange={(e) => setNewPromo({...newPromo, duration_days: parseInt(e.target.value)})}
            placeholder="Days"
            className="px-4 py-2 border rounded-lg"
            min="1"
          />
          <input
            type="number"
            value={newPromo.max_uses}
            onChange={(e) => setNewPromo({...newPromo, max_uses: parseInt(e.target.value)})}
            placeholder="Max Uses"
            className="px-4 py-2 border rounded-lg"
            min="1"
          />
          <button
            type="submit"
            disabled={creating}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
          >
            {creating ? 'Creating...' : 'Create'}
          </button>
        </form>
      </div>

      {/* Existing Promos */}
      <div className="bg-zinc-800 rounded-2xl border overflow-hidden">
        <table className="w-full">
          <thead className="bg-zinc-900">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Code</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Plan</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Duration</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Usage</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Status</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-zinc-400 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-700">
            {promoCodes?.promo_codes?.length === 0 ? (
              <tr><td colSpan="6" className="px-6 py-12 text-center text-zinc-400">No promo codes</td></tr>
            ) : (
              promoCodes?.promo_codes?.map((p) => (
                <tr key={p.promo_id} className="hover:bg-zinc-900">
                  <td className="px-6 py-4 font-mono font-medium">{p.code}</td>
                  <td className="px-6 py-4 capitalize">{p.plan}</td>
                  <td className="px-6 py-4">{p.duration_days} days</td>
                  <td className="px-6 py-4">{p.times_used || 0} / {p.max_uses}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2 py-1 text-xs rounded-full ${
                      p.is_active ? 'bg-green-500/20 text-green-400' : 'bg-zinc-800 text-zinc-200'
                    }`}>
                      {p.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => deletePromoCode(p.promo_id)}
                      className="p-2 text-red-400 hover:bg-red-500/10 rounded-lg"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
